<template>
  <div>
    <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
    <div>
      <div class="title-header-container mt-3 noprint">
        <h3 class="title-header mr-3">
          {{ $t("toolbar.alternativeNames.alternativeNames") }}
        </h3>
        <div v-if="showLanguageSelector" class="view-language-selector">
          <LanguageSelector
            :languages="languagesWithFlags"
            :value="currentLanguage"
            @change="changeViewLanguage"
          />
        </div>
      </div>
      <div class="mt-5">
        <AlternativeNames :allows_crud="allows_crud"></AlternativeNames>
      </div>
    </div>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import matterLanguageMixin from "@/mixins/matterLanguageMixin";

const FLAG_MAP = {
  es: require("@/assets/es_icon.png"),
  en: require("@/assets/us_icon.png"),
};

export default {
  name: "AlternativeNamesView",
  mixins: [matterLanguageMixin],
  components: {
    AlternativeNames: () => import("./AlternativeNames.vue"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
    LanguageSelector: () => import("@/components/reusable/LanguageSelector"),
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      languages: names.LANGUAGES,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        { text: this.$t("toolbar.alternativeNames.alternativeNames") },
      ];
    },
    allows_crud() {
      const has_permission = this.$hasPermissions(
        "common.change_alternativenames"
      );
      if (has_permission) return has_permission;
      else return false;
    },
    currentLanguage() {
      return this.$i18n.locale;
    },
    selectorLanguages() {
      return this.languages.filter(
        (x) => x.is_active || x.is_active_matter_view
      );
    },
    showLanguageSelector() {
      const active_count = this.languages.filter((x) => x.is_active).length;
      const active_matter_view_count = this.languages.filter(
        (x) => x.is_active_matter_view
      ).length;
      return active_count >= 2 || active_matter_view_count >= 2;
    },
    languagesWithFlags() {
      return this.selectorLanguages.map((lang) => ({
        ...lang,
        flag: FLAG_MAP[lang.code] || null,
      }));
    },
  },
  methods: {
    // Cambia el idioma solo en esta vista, usando el mismo contexto de
    // override que las vistas de asignatura (se revierte al salir).
    async changeViewLanguage(code) {
      const lang = this.selectorLanguages.find((l) => l.code === code);
      if (!lang || code === this.$i18n.locale) return;

      const context = this.$store.getters[names.MATTER_LANGUAGE_CONTEXT];

      if (context && code === context.savedLocale) {
        this.revertMatterLanguage();
        return;
      }

      if (!context) {
        const globalLocale =
          localStorage.getItem("user_language") || this.$i18n.locale;
        this.$store.commit(names.SET_MATTER_LANGUAGE_CONTEXT, {
          savedLocale: globalLocale,
          savedAlternativeNames: [
            ...this.$store.getters[names.ALTERNATIVE_NAMES],
          ],
        });
      }

      this.$i18n.locale = code;

      const altNames = await this.$restful.GetAll(
        `/common/alternative-names/?language_id=${lang.id}`
      );
      if (this.$store.getters[names.MATTER_LANGUAGE_CONTEXT]) {
        this.$store.commit(names.OVERRIDE_ALTERNATIVE_NAMES, altNames);
      }
    },
  },
  mounted() {},
  created() {
    this.$store.dispatch(names.FETCH_LANGUAGES);
  },
};
</script>
<style scoped>
.title-header-container {
  display: flex;
  justify-content: center;
}
.title-header {
  margin-bottom: 0;
}
.view-language-selector {
  display: inline-flex;
  align-items: center;
}
</style>